import React, { useContext } from "react";
import PropTypes from "prop-types";
import { InvoiceTemplateContext } from "../InvoiceTemplateContext";

import SelectableSection from "./SelectableSection";
import SelectableElement from "./SelectableElement";
import ValuePlaceholder from "./ValuePlaceholder";

const InvoiceTableSectionViewer = ({ invoiceData }) => {
  const { showValuePlaceHolder, withTableSummary } = useContext(
    InvoiceTemplateContext
  );

  const { invoiceTableSection, bilingualEnabled } = invoiceData;
  const {
    border,
    numberOfLines,
    tableStyle,
    tableHeadStyle,
    summaryRowStyle,
    cellStyle,
    fields,
    summaryFields,
    hasNumberSymbol,
  } = invoiceTableSection;

  const borderRowStyle = border.enabled ? border.style : {};

  return (
    <SelectableSection
      section="invoiceTableSection"
      isSelectable={invoiceTableSection.isSelectable}
      style={{ position: "relative", zIndex: 99 }}
    >
      <table style={tableStyle} className="invoice-heading">
        <thead className="invoice-table-heading">
          <tr style={tableHeadStyle}>
            {fields.map((field, index) => (
              <td key={index} style={{ ...cellStyle, ...field.style }}>
                <div>
                  <SelectableElement
                    as="span"
                    style={field.labelStyle.vi}
                    id={`invoiceTableSection.fields[${index}].label.vi`}
                    stylePath={`invoiceTableSection.fields[${index}].labelStyle.vi`}
                  >
                    {field.label.vi}
                  </SelectableElement>
                </div>
                {bilingualEnabled && (
                  <div>
                    <SelectableElement
                      as="span"
                      style={field.labelStyle.en}
                      id={`invoiceTableSection.fields[${index}].label.en`}
                      stylePath={`invoiceTableSection.fields[${index}].labelStyle.en`}
                    >
                      {field.label.en}
                    </SelectableElement>
                  </div>
                )}
              </td>
            ))}
          </tr>
          {hasNumberSymbol && (
            <tr style={tableHeadStyle}>
              {fields.map((field, index) => (
                <td key={index} style={cellStyle}>
                  <SelectableElement
                    as="div"
                    style={field.numberSymbolStyle}
                    id={`invoiceTableSection.fields[${index}].numberSymbol`}
                    stylePath={`invoiceTableSection.fields[${index}].numberSymbolStyle`}
                  >
                    {field.numberSymbol}
                  </SelectableElement>
                </td>
              ))}
            </tr>
          )}
        </thead>
        <tbody>
          {showValuePlaceHolder ? (
            <>{`{{tbody}}`}</>
          ) : (
            <>
              {Array(numberOfLines)
                .fill(1)
                .map((item, index) => (
                  <tr key={index} style={borderRowStyle}>
                    {fields.map((field, index) => (
                      <td key={index} style={cellStyle}></td>
                    ))}
                  </tr>
                ))}
            </>
          )}

          {Boolean(withTableSummary) &&
            summaryFields.map((field, index) => (
              <tr key={index} style={summaryRowStyle}>
                <td
                  style={{ ...cellStyle, ...field.style }}
                  colSpan={field.colSpan}
                >
                  <span style={field.labelStyle.vi}>{field.label.vi} </span>
                  {bilingualEnabled && (
                    <span style={field.labelStyle.en}>{field.label.en}</span>
                  )}
                  <span style={field.delimiterStyle}>{field.delimiter} </span>
                </td>
                {field.hasValue && (
                  <td>
                    <ValuePlaceholder
                      placeholderKey={field.name}
                    ></ValuePlaceholder>
                  </td>
                )}
              </tr>
            ))}
        </tbody>
      </table>
    </SelectableSection>
  );
};

InvoiceTableSectionViewer.propTypes = {
  invoiceData: PropTypes.object,
};

export default InvoiceTableSectionViewer;
